// 机构管理
import { handleService } from './common'

const prefix = '/api/Agency'

const url = {
  add: prefix + '/Add',
  getListByPage: prefix + '/GetListByPage',
  update: prefix + '/Update',
  delete: prefix + '/Delete',
  getInfo: prefix + '/Get',
  resetPassword: prefix + '/ResetPassword'
}

export default {
  getListByPage (data) {
    return handleService(url.getListByPage, data)
  },
  add (data) {
    return handleService(url.add, data, 'post')
  },
  update (data) {
    return handleService(url.update, data, 'put')
  },
  delete (data) {
    return handleService(url.delete, data, 'delete')
  },
  getInfo (data) {
    return handleService(url.getInfo, data)
  },
  // 重置密码
  resetPassword (data) {
    return handleService(url.resetPassword, data)
  }
}
